// tslint:disable:max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";
import { theme } from "styles/theme";

const LinkBrokenIcon = (props) => {
    const { fill = theme.palette.darkGrey } = props;
    return (
        <SvgIcon {...props}>
            <path
                fill="none"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.9,8.4c0.3-2.2-0.4-3.1-1.9-3.4c-1.3-0.3-2.6,0.4-3.1,2.2l-0.2,1.4"
            />
            <path
                fill="none"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12,13.5c0.9,1.2,2.8,1.4,3.9,0.5c0.1-0.1,0.2-0.2,0.3-0.2l0.2-0.3"
            />
            <path
                fill="none"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.6,11.7c-0.9-1.2-2.5-1.4-3.7-0.5c-0.1,0.1-0.2,0.2-0.3,0.2l-1.9,2c-1,1-1,2.7,0.1,3.7c1,1,2.6,1,3.6,0.2l0.9-0.9"
            />
        </SvgIcon>
    );
};

export default LinkBrokenIcon;
